import {
  $jinglesTableFilters,
  $jinglesTablePage,
  $jinglesTablePageSize,
  $jinglesTableSearch,
  $jinglesTableSort,
  type TracksSortState,
} from '@/entities/tracks'
import { type GetApiTracksQueryParams } from '@/shared/api'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@/shared/lib/query'
import { createStore, sample } from 'effector'
import { createGate } from 'effector-react'

// Gate
export const JinglesListPageJinglesGate = createGate()

// Last state

// Filters
export const $jinglesListPageLatestJinglesFilters =
  createStore<GetApiTracksQueryParams>({})
sample({
  source: $jinglesTableFilters,
  clock: JinglesListPageJinglesGate.close,
  target: $jinglesListPageLatestJinglesFilters,
})
// Sort
export const $jinglesListPageLatestJinglesSort = createStore<TracksSortState>({
  field: null,
  order: null,
})
sample({
  source: $jinglesTableSort,
  clock: JinglesListPageJinglesGate.close,
  target: $jinglesListPageLatestJinglesSort,
})
// Page
export const $jinglesListPageLatestJinglesPage =
  createStore<number>(DEFAULT_PAGE)
sample({
  source: $jinglesTablePage,
  clock: JinglesListPageJinglesGate.close,
  target: $jinglesListPageLatestJinglesPage,
})
// Page size
export const $jinglesListPageLatestJinglesPageSize =
  createStore<number>(DEFAULT_PAGE_SIZE)
sample({
  clock: JinglesListPageJinglesGate.close,
  source: $jinglesTablePageSize,
  target: $jinglesListPageLatestJinglesPageSize,
})
// Search
export const $jinglesListPageLatestJinglesSearch = createStore<string>('')
sample({
  clock: JinglesListPageJinglesGate.close,
  source: $jinglesTableSearch,
  fn: (search) => search || '',
  target: $jinglesListPageLatestJinglesSearch,
})
